import styled, { css } from 'styled-components/macro';

import { DefinitionLabel } from 'styles/base-classes';
import Box from 'components/elements/Box';
import KeyValueGroup from 'components/base/KeyValueGroup/KeyValueGroup';
import { Data, Group } from 'components/base/KeyValuePair/KeyValuePair';
import { Header } from 'components/data-containers/KPIs/shared/index';

export const ContentBox = styled(Box)`
  position: relative;
`;

export const CountriesBox = styled(Box)`
  h4 {
    margin-bottom: 0;
  }
  ol {
    margin-top: 0.75em;
    margin-bottom: 1em;
  }
`;

export const HeaderTitle = styled(Header)`
  color: ${({ theme }) => theme.NightBlue};
`;

export const MetricDefinitionLabel = styled(DefinitionLabel)`
  margin-bottom: 0;
`;

export const KeyValueGroupContainer = styled(KeyValueGroup)<any>`
  ${Group} {
    ${({ isMobileView }): any =>
      !isMobileView
        ? css`
            ${Data} {
              font-size: 1rem;
              line-height: 2rem;
            }
            &:first-of-type ${Data} {
              font-size: 1rem;
              line-height: 2rem;
              & > span {
                font-size: 1.5rem;
              }
            }
          `
        : css``};
  }
`;

export const VerticalBorder = styled('div')`
  width: 2px;
  height: 190px;
  background-color: #e8ebed;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
